import type { Building } from "building-types/building/buildingTypes";
import type { Level } from "building-types/levels/levelTypes";
import { GROUND_LEVEL } from "common/constants/buildingObjects";
import type { Table } from "common/data/table";
import { DIST_Z_FIGHT } from "geom/core";
import { groundLevel } from "./levelTools";

export function buildingGroundZ(building: Building) {
  if (!building) {
    return GROUND_LEVEL;
  }
  const ground = groundLevel(building.levels);

  if (!ground) {
    return GROUND_LEVEL;
  }

  return ground.floorElevation + ground.levelDatumsGenerated.grade - DIST_Z_FIGHT;
}

export function levelsGroundZ(levels: Table<Level>) {
  if (!Object.values(levels).length) {
    return GROUND_LEVEL;
  }

  const ground = groundLevel(levels);

  if (!ground) {
    return GROUND_LEVEL;
  }

  return ground.floorElevation + ground.levelDatumsGenerated.grade - DIST_Z_FIGHT;
}
